import React, { useState } from 'react';
import './modalLibro.css';

const ifButton = (blog_gruid, idioma, titulo) => {

  if (blog_gruid !== null) {

    return <div class="buton_bp2_div"><a class="buton_bp2 espac" href={'https://www.ricardosalinas.com/blog/' + blog_gruid + '?lang=' + idioma}>Blog </a></div>;

  } else {
    if (titulo == 'Cómo pensar la economía' || titulo == 'How to Think About the Economy: A Primer') {
      console.log("Entro al libro");
      var blogtext2 = idioma == "es" ? "Descarga" : "Download";
      return <div class="buton_bp2_div"><a target="_blank" class="buton_bp2 espac" href={'https://play.google.com/store/books/details?id=Cdq-EAAAQBAJ&pli=1'}>{blogtext2} </a></div>;

    }
    else {
      return "";
    }

  }

};
const ModalLibro = ({ isOpen, closeModal, variable1, variable2, variable3, variable4, variable5, variable6, variable7, variable8, variable9 }) => {
  if (!isOpen) return null;

  return (

    <div className="modal_Lib">
      <div className="modalContent_Lib">

        {/* <div dangerouslySetInnerHTML={{__html:variable1}}>
        </div> */}


        <div className='row'>
          <div className='colum1_Libr_modal'>
            {/* <img class="imgG_bp" src={variable1} +{variable2} alt={"ejemplo"} /> */}
            <img className="imgG_modalLibro" src={variable1} alt={variable2} />


          </div>
          <div className='colum2_Libr_modal'>
            <div className='row_modal'>
              <h3 className='modal-title' > {variable3}</h3>
              <hr />
              <p className='card-text'> {variable4}</p>
              {/* <p> {variable5}</p>
            <p> {variable6}</p>
            <p> {variable7}</p> */}
            </div>
            <div className='row_modal2'>
              <div className='colum2_Libr_modal'>
                <p className='datosLibr'> {variable5}</p>
                <p className='datosLibr'> {variable6}</p>
                <p className='datosLibr'> {variable7}</p>
                {/* <p>oy varia 8 +{variable8}</p> */}
                {/* <p> soy varia 9 +{variable9}</p> */}
              </div>

              {/* if({variable8}!=null ){ */}


              {ifButton(variable8, variable9, variable3)}



              {
                // if(variable8!=null){
                // 'https://www.ricardosalinas.com/blog/es/c224c4fb-a8f4-4e92-af14-02b98741c594'
                // <a class="buton_bp" target="_blank" href="#">blog</a>



              }


              {/* <div className='colum2_Libr_modal'> */}


              {/* </div> */}
            </div>
          </div>
        </div>

        {/* <p>Variable 2: {variable2}</p> */}
        <button className="botonPop_Lib tache" onClick={closeModal}><span aria-hidden="true">×</span></button>
      </div >
      <div className="background_gri_Lib"></div>
    </div >
  );
};

export default ModalLibro;